export default from './member-confirmation';



// WEBPACK FOOTER //
// ./app/components/member-confirmation/index.js